import deleteService from "../deleteService";
import getService from "../getService";
import postService from "../postService";
import putService from "../putService";

const CONFIG_API_URL =
  process.env.REACT_APP_API_BASE_URL || "http://20.126.75.78/naptin/api/v1/";

export default class UserAdminService {
  static async getUsers(param: string) {
    const response = await getService.get(
      `${CONFIG_API_URL}admin/users-by-category/${param}`
    );
    const data: any = response.data;
    return data;
  }

  // static async downloadTemplate( param : string | undefined ) {
  //     const response = await getService.get(`${CONFIG_API_URL}course-availability/${param}/download-result-upload-template`);
  //     const data: any = response.data;
  //     return data;
  // }

  static async downloadTemplate(param: string | undefined) {
    const response = await getService.get(
      `${CONFIG_API_URL}course-availability/${param}/download-result-upload-template`,
      {
        responseType: "blob", // Specify responseType as 'blob'
      }
    );
    return response.data; // Return the blob data
  }

  static async downloadAttendanceTemplate(param: string | undefined) {
    const response = await getService.get(
      `${CONFIG_API_URL}attendances/export-attendance/course/${param}`,
      {
        responseType: "blob", // Specify responseType as 'blob'
      }
    );
    return response.data; // Return the blob data
  }

  static async getUser(uuid: string | undefined) {
    const response = await getService.get(
      `${CONFIG_API_URL}admin/users/${uuid}`
    );
    const data: any = response.data;
    return data;
  }

  static async getUserProfileHistory(userId: string | undefined | number) {
    const response = await getService.get(
      `${CONFIG_API_URL}admin/user-profile-updates/${userId}`
    );
    const data: any = response.data;
    return data;
  }

  static async createUser(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}admin/users`,
      data
    );
    return response.data;
  }

  static async createUserBulk(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}admin/users-bulk`,
      data
    );
    return response.data;
  }

  static async updateUser(data: any, uuid: string | undefined) {
    const response = await putService.put(
      `${CONFIG_API_URL}admin/users/${uuid}`,
      data
    );
    return response.data;
  }
  static async deleteUser(uuid: string | undefined) {
    const response = await deleteService.delete(
      `${CONFIG_API_URL}admin/users/${uuid}`
    );
    const data: any = response.data;
    return data;
  }
}
